import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { appList, appDetails } from "../mockData";
import { useLayoutEffect } from "react";
const AIXApplications = () => {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  const [selectedApp, setSelectedApp] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const selectedDetails = selectedApp
    ? appDetails.find((d) => d.code === selectedApp.code)
    : null;

  const handleCardClick = (app) => {
    setSelectedApp(app);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedApp(null);
  };

  return (
    <div
      className="relative text-white h-full min-h-screen w-full flex flex-col items-center justify-between px-4 md:px-8 overflow-hidden"
      style={{
        background: `radial-gradient(circle at 20% 0%, rgba(0,0,0,1) 25%, rgba(80,0,0,0.9) 70%, rgba(150,0,0,0.8) 100%)`,
      }}
    >
      {/* Glowing red overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-600/10 via-transparent to-red-800/10 animate-pulse-slow pointer-events-none"></div>

      {/* Logo */}
      <div className="absolute top-4 left-4">
        <img
          src="/images/aix.png"
          alt="AIX Logo"
          className="w-24 h-12 md:w-28 md:h-16 object-contain"
        />
      </div>

      {/* Header */}
      <div className="absolute top-6 left-0 w-full flex flex-col items-center justify-center animate-fade-down">
        {/* <h1 className="text-2xl md:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-red-400 to-red-600 drop-shadow-[0_0_20px_rgba(255,0,0,0.5)]">
          AIX Applications
        </h1> */}
      </div>

      {/* Grid Section */}
      <div className="flex-1 flex items-center justify-center w-full mt-14 md:mt-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-8 gap-y-10 justify-items-center w-full max-w-6xl px-4">
          {appList.map((app) => (
            <div
              key={app.code}
              onClick={() => handleCardClick(app)}
              className="flex flex-col items-center cursor-pointer transition-transform duration-300 hover:scale-105"
            >
              <img
                src={app.image}
                alt={app.name}
                className={`w-12 h-12 md:w-16 md:h-16 rounded-full border-2 shadow-lg object-cover ${
                  selectedApp?.code === app.code
                    ? "border-emerald-400 shadow-[0_0_10px_rgba(16,185,129,0.7)]"
                    : "border-gray-700"
                }`}
              />
              <p className="mt-2 text-xs md:text-sm font-medium text-gray-300 text-center w-24 truncate">
                {app.name}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="pb-4 text-xs md:text-sm text-gray-500">
        AIX Platform
      </div>

      {/* Modal */}
      {showModal && selectedDetails && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
          <Card className="bg-gradient-to-b from-gray-900 to-black text-white border border-emerald-400/40 rounded-xl w-10/12 max-w-xl shadow-2xl relative animate-fade-in-up">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-white text-xl font-bold"
              onClick={closeModal}
            >
              ✕
            </button>
            <CardContent className="p-4 text-center">
              <img
                src={selectedApp.image}
                alt={selectedApp.name}
                className="w-16 h-16 rounded-full mx-auto mb-3 border-2 border-emerald-400 shadow-md"
              />
              <h2 className="text-xl font-semibold mb-1 text-emerald-400">
                {selectedDetails.shortTitle}
              </h2>
              <p className="text-xs text-gray-400 mb-2">
                <span className="font-semibold text-gray-300">UC ID:</span>{" "}
                {selectedDetails.ucId}
              </p>
              <p className="text-gray-300 mb-3 leading-relaxed text-xs md:text-sm">
                {selectedDetails.overview}
              </p>

              <div className="flex flex-col items-center">
                <ul className="list-disc text-gray-400 text-left inline-block space-y-1 mb-4 text-xs md:text-sm">
                  {selectedDetails.features?.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>

                <Button
                  className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-1 rounded-lg font-semibold transition duration-300 text-sm"
                  onClick={() =>
                    alert(`Opening ${selectedDetails.shortTitle}...`)
                  }
                >
                  View Application
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default AIXApplications;
